<template>
  <div>
    <v-subheader class="title-setting">Stock</v-subheader>

    <v-form v-on:submit.prevent="save">
      <div class="col-md-12">
        <div class="col-md-12">
          <p class="title_bi">Configuración de Stock por Documento</p>
          <p class="caption">
            Configure el comportamiento del sistema de stock en base a los documentos de compra y venta (Remitos).
          </p>

          <v-checkbox 
            label="Activar gestión de stock por documento" 
            v-model="mainItem.stock_by_document"
            hint="Cuando está activo, el stock se modifica solo a través de Remitos de Venta y Remitos de Compra"
            persistent-hint
            class="mt-2"
          ></v-checkbox>
        </div>

        <div class="col-md-6 mt-4" v-if="mainItem.stock_by_document">
          <v-menu
            ref="menu"
            v-model="menu_date"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="mainItem.stock_by_document_start_date"
                label="Fecha de inicio"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                hint="A partir de esta fecha se aplicará la lógica de stock por documento"
                persistent-hint
                filled
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="mainItem.stock_by_document_start_date"
              no-title
              scrollable
              @input="menu_date = false"
            >
            </v-date-picker>
          </v-menu>
          <span class="caption grey--text">
            Los comprobantes anteriores a esta fecha seguirán usando la lógica anterior.
          </span>
        </div>

        <div class="col-md-12 mt-4 text-right">
          <v-btn color="green darken-1" text :loading="loading" type="submit"> Guardar </v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    mainItem: Object,
    createItem: Function,
    loading: Boolean,
  },
  data() {
    return {
      menu_date: false,
    };
  },
  mounted() {},
  methods: {
    save(e) {
      this.$emit("createItem", e);
    },
  },
};
</script>
